import {mode$} from '@px/streams/spot';
import {allSymbols$ as spotAllSymbols$} from '@px/streams-spot/all-symbols';
import {allSymbols$ as marginAllSymbols$} from '@px/streams-margin/all-symbols';
import {SPOT_TRADE_MODE} from './enum';
import {createSpotModeState$} from './utils';

export const [allSymbols$, updateAllSymbols$] = createSpotModeState$<boolean>(
  mode$,
  {
    [SPOT_TRADE_MODE.Margin]: marginAllSymbols$,
    [SPOT_TRADE_MODE.Spot]: spotAllSymbols$,
  },
  false
);
